import { render } from "./Sort.vue?vue&type=template&id=0a34f012&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"

import "./Sort.vue?vue&type=style&index=0&id=0a34f012&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a34f012"]])

export default __exports__